interface DotGridProps {
  color?: string;
  size?: number;
  opacity?: number;
  dot?: number;
}

export const DotGrid = ({ color = "rgba(234,234,234,0.06)", size = 12, opacity = 1, dot = 1.6 }: DotGridProps) => (
  <div
    aria-hidden
    className="pointer-events-none absolute inset-0"
    style={{
      opacity,
      backgroundImage: `radial-gradient(${color} ${dot}px, transparent ${dot}px)`,
      backgroundSize: `${size}px ${size}px`,
    }}
  />
);
